import * as Constants from './constants'

export const khoListRequest = function khoListRequest(formData) {
  return {
    type: Constants.KHO_LIST_REQUESTING,
    payload: formData
  }
}

export const khoListSuccess = function khoListSuccess(data) {
  return {
    type: Constants.KHO_LIST_SUCCESS,
    data
  }
}

export const khoListError = function khoListError(error) {
  return {
    type: Constants.KHO_LIST_ERROR,
    error
  }
}

export const khoDetailRequest = function khoDetailRequest(formData) {
  return {
    type: Constants.KHO_DETAIL_REQUESTING,
    payload: formData
  }
}

export const khoDetailSuccess = function khoDetailSuccess(data) {
  return {
    type: Constants.KHO_DETAIL_SUCCESS,
    data
  }
}

export const khoDetailError = function khoDetailError(error) {
  return {
    type: Constants.KHO_DETAIL_ERROR,
    error
  }
}

export const khoUpdateRequest = (formData, callback) => {
  return {
    type: Constants.KHO_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const khoUpdateSuccess = function khoUpdateSuccess(response) {
  return {
    type: Constants.KHO_UPDATE_SUCCESS,
    payload: response
  }
}

export const khoUpdateError = function khoUpdateError(error) {
  return {
    type: Constants.KHO_UPDATE_ERROR,
    error
  }
}

export const usersListRequest = function usersListRequest(formData) {
  return {
    type: Constants.USERS_LIST_REQUESTING,
    payload: formData
  }
}

export const usersListSuccess = function usersListSuccess(data) {
  return {
    type: Constants.USERS_LIST_SUCCESS,
    data
  }
}

export const usersListError = function usersListError(error) {
  return {
    type: Constants.USERS_LIST_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Kho/actions.js